<script setup>
const emit = defineEmits(['confirm']);

const clickConfirm = () => emit('confirm');
</script>

<template>
  <div class="drawer-error">
    <div class="drawer-error__message">
      일시적으로 오류가 발생했습니다.<br>새로고침 후 다시 시도해 주세요.
    </div>
    <button
      class="drawer-error__confirm"
      @click="clickConfirm">
      확인
    </button>
    <div class="drawer-error__message">
      지속적인 오류나 불편사항은 고객센터로 문의해 주시면<br>
      친절하게 해결해 드리겠습니다.
    </div>
  </div>
</template>

<style scoped>
.drawer-error {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.drawer-error__confirm {
  margin-bottom: 20px;
  display: flex;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  border: 1px solid var(--orange-300-main, #EB4C10);
  background: var(--gray-100-white, #FFF);
  color: var(--orange-300-main, #EB4C10);
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px; /* 116.667% */
}
.drawer-error__message {
  text-align: center;
  line-height: 24px;
}
</style>